const CheckboxForm = (props) => {
  const { name, validation, renderFunc, captionFalse, setValue, register, handleSubmit, watch, control, className, margin, error, label, caption, ...rest } = props
  return (
    <div className={"form-group " + margin}>
      {label && <label>{label}</label>}
      <div className="form-check">
        <input {...register(name, validation)} type="checkbox" className={`form-check-input ${error ? "is-invalid" : ""} ${className}`} {...rest} />
        {caption && <label>{caption}</label>}
      </div>
      {error && <span className="text-danger">{error}</span>}
    </div>
  );
};

CheckboxForm.defaultProps = {
  register: () => { },
  name: "",
  validation: {},
  className: "",
  error: "",
  label: "",
  margin: "mb-3"
}

export default CheckboxForm;